export enum PasswordStrength {
  VERY_WEAK = 0,
  WEAK = 1,
  FAIR = 2,
  GOOD = 3,
  STRONG = 4,
  VERY_STRONG = 5,
}

export const passwordValidationRules = {
  minLength: 8,
  hasUpperCase: /[A-Z]/,
  hasLowerCase: /[a-z]/,
  hasNumber: /\d/,
  hasSpecialChar: /[!@#$%^&*()_+\-=[\]{};:'",.<>?]/,
};

export const LOGIN_REDIRECT_URL = "/dashboard";
export const REQUIRED_PASSWORD_CHANGE_URL = "/auth/change-password";
